export const themeCSSConstants = {
	THUMBICONSTYLE: {
    activeThumb: {
      base: '#1784e3',
    },
    inactiveThumb: {
      base: 'rgb(0, 0, 0)',
    },
    active: {
      base: '#fff',
      hover: '#f5f5f5',
    },
    inactive: {
      base: '#fff',
      hover: '#f5f5f5',
    }
  },
  DISABLECOLOR : {
    active: {
      base: 'rgb(110, 110, 110)',
      hover: 'rgb(90, 90, 90)',
    },
    inactive: {
      base: 'rgb(110, 110, 110)',
      hover: 'rgb(90, 90, 90)',
    }
  },
  THUMBSTYLE:{
  	width:"16px", 
  	height:"16px", 
  	display:"flex", 
  	alignSelf:" center",
    borderRadius:" 50%", 
    boxShadow: "none",
  	boxSizing:" borderBox", 
  	position:" relative", 
  	backgroundColor:" rgb(62, 130, 247)", left:" -10px"
  },
  TRACKSTYLE: {
    height: "22px",
    width: "50px",
    border: "1px solid #bfbfbf"
  }
}


// WEBPACK FOOTER //
// ./src/redux/constant/themeCSS.jsx